// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2sy1q","signatureButtonsRight":"ModalSign_signatureButtonsRight__2SwTj"};